import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'activityLog';

// Action Types
export const types = {
  GET_ACTIVITY_LOG: createAsyncTypes(`${KEY}/GET_ACTIVITY_LOG`),
  RESET_ACTIVITY_LOG: `${KEY}/RESET_ACTIVITY_LOG`,
  RESET_EXPORT_DATA: `${KEY}/RESET_EXPORT_DATA`,
  GET_KIOSK_LATEST_ACTIVITY_LOG: createAsyncTypes(`${KEY}/GET_KIOSK_LATEST_ACTIVITY_LOG`)
};

export interface BaseEvent {
  clientId: string;
  actorInfo: {
    name?: string;
  };
  createdAt: string;
  name: string;
  event: string;
  category: string;
}

export interface KioskEvent extends BaseEvent {
  kioskId: string;
}

export interface HardwareEvent extends BaseEvent {
  kioskHardwareId: string;
}

export interface ActivityLogState {
  readonly activityLog: BaseEvent[];
  readonly totalRecords: number;
  readonly hasMore: boolean;
  readonly error: string | null;
  readonly pending: boolean;
  readonly export: {
    readonly data: BaseEvent[];
    readonly pending: boolean;
  };
  readonly latestKioskActivityLog: {
    readonly kioskEvents: KioskEvent[];
    readonly kioskHardwareEvents: HardwareEvent[];
    readonly error: string | null;
    readonly pending: boolean;
  };
}

export interface GetActivityLogRequest {
  type: typeof types.GET_ACTIVITY_LOG.REQUEST;
  payload: {
    page: number;
    kioskIds: string[];
    userNames: string[];
    startTime: Date;
    endTime: Date;
    sort: string;
    sortColumn: string;
    exportData?: boolean;
  };
}

export interface GetActivityLogError {
  type: typeof types.GET_ACTIVITY_LOG.ERROR;
  payload: string;
}

export interface GetActivityLogPending {
  type: typeof types.GET_ACTIVITY_LOG.PENDING;
  payload: { pending: boolean; exportData: boolean };
}

export interface GetActivityLogSuccess {
  type: typeof types.GET_ACTIVITY_LOG.SUCCESS;
  payload: { data: BaseEvent[]; total: number; exportData: boolean };
}

export interface ResetActivityLog {
  type: typeof types.RESET_ACTIVITY_LOG;
}

export interface ResetExportData {
  type: typeof types.RESET_EXPORT_DATA;
}

export interface GetKioskLatestActivityRequest {
  type: typeof types.GET_KIOSK_LATEST_ACTIVITY_LOG.REQUEST;
  payload: { kioskId: string };
}

export interface GetKioskLatestActivityError {
  type: typeof types.GET_KIOSK_LATEST_ACTIVITY_LOG.ERROR;
  payload: string;
}

export interface GetKioskLatestActivityPending {
  type: typeof types.GET_KIOSK_LATEST_ACTIVITY_LOG.PENDING;
  payload: boolean;
}

export interface GetKioskLatestActivitySuccess {
  type: typeof types.GET_KIOSK_LATEST_ACTIVITY_LOG.SUCCESS;
  payload: {
    kioskEvents: KioskEvent[];
    kioskHardwareEvents: HardwareEvent[];
  };
}

export type ActivityLogActionTypes =
  | ResetActivityLog
  | ResetExportData
  | GetActivityLogRequest
  | GetActivityLogSuccess
  | GetActivityLogError
  | GetActivityLogPending
  | GetKioskLatestActivityRequest
  | GetKioskLatestActivitySuccess
  | GetKioskLatestActivityError
  | GetKioskLatestActivityPending;
